import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export const OBSERVER_CONFIG = {
  threshold: [0.3, 0.5, 0.7],
  rootMargin: '-10% 0px -50% 0px',
};

export const VISIBILITY_THRESHOLDS: Record<DevelopmentTool, number> = {
  [DevelopmentTool.BLOCKS]: 0.15,
  [DevelopmentTool.CLI]: 0.15,
  [DevelopmentTool.DEV_CENTER]: 0.25,
  [DevelopmentTool.UNKNOWN_TEMPLATE_TYPE]: 0.2,
};
